module.exports = "/_next/static/images/DeepenYourUnderstanding-49983c39facf498fab6a58253909e8b6.webp";